import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/privacy/components/PrivacyClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ParticleBackground.tsx");
